import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'logzy-billu',
  templateUrl: './billu.component.html',
  styleUrls: ['./billu.component.scss']
})
export class BilluComponent implements OnInit {
  i = 0;
  clickIt: boolean = true;

  @ViewChild('work')
  work!: any;

  @ViewChild('shift')
  shift!: any;

  @Output() action1: EventEmitter<any> = new EventEmitter();

  @Input()
  part1: string;
  @Input()
  part2: string;
  @Input()
  part3: string;
  @Input()
  font: string;
  @Input()
  button: boolean = false;
  @Input()
  chotu:boolean=false;


  changer = setInterval(() => {
    // console.log(this.i);
    if (this.button == false) {
      var color = ["#F05F25", "#9E9E9E", "#FF9064", "#414042"];
      this.work.nativeElement.style.background = color[this.i];
      this.shift.nativeElement.style.bottom = `0.${this.i}em`;
      this.i = (this.i + 1) % color.length;
    }
    // console.log(this.work.nativeElement.style.background);
    if (this.i == 50) {
      console.log('Break Time');
      clearInterval(this.changer)
    }
  }, 800);


  action() {
    this.clickIt = false;
    this.action1.emit();
  }
  constructor() { }

  ngOnInit(): void {
    this.changer;
  }

}
